const ARABIC_DIACRITICS_AND_TATWEEL = /[ً-ٰٟـ]/g;
const ARABIC_ALEF_VARIANTS = /[أإآٱ]/g;
const PUNCTUATION = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~،؛؟«»…]/g;

const arabicNormalize = (value) => {
  if (value === undefined || value === null) return '';

  return value
    .toString()
    .replace(ARABIC_DIACRITICS_AND_TATWEEL, '')
    .replace(ARABIC_ALEF_VARIANTS, 'ا')
    .replace(/ؤ/g, 'و')
    .replace(/ئ/g, 'ي')
    .replace(/ء/g, '')
    .replace(/ى/g, 'ي')
    .replace(/ة/g, 'ه')
    .replace(PUNCTUATION, ' ')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
};

export default arabicNormalize;
